// test1997
(1997 && 0);
